.container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.container iframe {
    min-width: 0 !important;
}

.bee-wrapper {
    width: 100%;
    height: 100%;
    flex-grow: 1;
}
